import { defineComponent, createBlock, openBlock, Teleport, createElementBlock, createCommentVNode, mergeProps, createElementVNode, createVNode, toDisplayString, Fragment, renderList, withCtx, unref, resolveDynamicComponent } from "vue";
import { _ as _sfc_main$1 } from "./p-btn.js";
import PCloseBtn from "../p-close-btn.js";
import PDropdown from "../p-dropdown.js";
import { _ as _sfc_main$2 } from "./p-icon.js";
import { isComponent } from "../component.js";
import { isString } from "../string.js";
const _hoisted_1 = { class: "flex h-12 w-max select-none items-center rounded-lg bg-p-purple-60 px-2 text-sm font-medium text-white" };
const _hoisted_2 = { class: "mx-4 whitespace-nowrap" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = { class: "flex items-center gap-2 px-1" };
const _hoisted_5 = { class: "flex items-center gap-2 px-1" };
const _hoisted_6 = { class: "bg-p-purple-60 py-2" };
const _hoisted_7 = { class: "flex items-center gap-2 px-1" };
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PActionBar",
    inheritAttrs: false
  },
  __name: "p-action-bar",
  props: {
    show: { type: Boolean },
    label: {},
    actions: {}
  },
  emits: ["click:dismiss", "click:action"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        _ctx.show ? (openBlock(), createElementBlock("div", mergeProps({
          key: 0,
          class: "fixed bottom-6 left-1/2 z-[100] -translate-x-2/4",
          role: "alertdialog"
        }, _ctx.$attrs), [
          createElementVNode("div", _hoisted_1, [
            createElementVNode("div", {
              class: "mr-4 flex cursor-pointer items-center",
              onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("click:dismiss"))
            }, [
              createVNode(PCloseBtn, {
                variant: "dark",
                class: "-mr-1"
              }),
              _cache[1] || (_cache[1] = createElementVNode("div", { class: "text-xs" }, "Clear All", -1))
            ]),
            _cache[2] || (_cache[2] = createElementVNode("div", { class: "h-9 w-0.5 shrink-0 rounded bg-p-purple-50" }, null, -1)),
            createElementVNode("p", _hoisted_2, toDisplayString(_ctx.label), 1),
            _cache[3] || (_cache[3] = createElementVNode("div", { class: "mr-2 h-9 w-0.5 shrink-0 rounded bg-p-purple-50" }, null, -1)),
            createElementVNode("div", _hoisted_3, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.actions, (actionOrMenu) => {
                return openBlock(), createElementBlock(Fragment, {
                  key: `action-${actionOrMenu.label}`
                }, [
                  !actionOrMenu.subActions ? (openBlock(), createBlock(_sfc_main$1, {
                    key: 0,
                    size: "sm",
                    type: "secondary-ghost-dark",
                    onClick: ($event) => _ctx.$emit("click:action", actionOrMenu.name)
                  }, {
                    default: withCtx(() => [
                      createElementVNode("div", _hoisted_4, [
                        unref(isComponent)(actionOrMenu.icon) ? (openBlock(), createBlock(resolveDynamicComponent(actionOrMenu.icon), {
                          key: 0,
                          class: "h-4 w-4"
                        })) : createCommentVNode("", true),
                        unref(isString)(actionOrMenu.icon) ? (openBlock(), createBlock(_sfc_main$2, {
                          key: 1,
                          icon: actionOrMenu.icon,
                          width: "16"
                        }, null, 8, ["icon"])) : createCommentVNode("", true),
                        createElementVNode("div", null, toDisplayString(actionOrMenu.label), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"])) : (openBlock(), createBlock(PDropdown, {
                    key: 1,
                    placement: "top",
                    strategy: "fixed"
                  }, {
                    popper: withCtx(({ hide }) => [
                      createElementVNode("ul", _hoisted_6, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(actionOrMenu.subActions, (subaction) => {
                          return openBlock(), createElementBlock("li", {
                            key: `subaction-${subaction.name}`
                          }, [
                            createVNode(_sfc_main$1, {
                              size: "sm",
                              class: "w-full [&>.items-center]:justify-start",
                              type: "secondary-ghost-dark",
                              onClick: ($event) => (_ctx.$emit("click:action", subaction.name), hide())
                            }, {
                              default: withCtx(() => [
                                createElementVNode("div", _hoisted_7, [
                                  unref(isComponent)(subaction.icon) ? (openBlock(), createBlock(resolveDynamicComponent(subaction.icon), {
                                    key: 0,
                                    class: "h-4 w-4"
                                  })) : createCommentVNode("", true),
                                  unref(isString)(subaction.icon) ? (openBlock(), createBlock(_sfc_main$2, {
                                    key: 1,
                                    icon: subaction.icon,
                                    width: "16"
                                  }, null, 8, ["icon"])) : createCommentVNode("", true),
                                  createElementVNode("div", null, toDisplayString(subaction.label), 1)
                                ])
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]);
                        }), 128))
                      ])
                    ]),
                    default: withCtx(() => [
                      createVNode(_sfc_main$1, {
                        size: "sm",
                        type: "secondary-ghost-dark"
                      }, {
                        default: withCtx(() => [
                          createElementVNode("div", _hoisted_5, [
                            unref(isComponent)(actionOrMenu.icon) ? (openBlock(), createBlock(resolveDynamicComponent(actionOrMenu.icon), {
                              key: 0,
                              class: "h-4 w-4"
                            })) : createCommentVNode("", true),
                            unref(isString)(actionOrMenu.icon) ? (openBlock(), createBlock(_sfc_main$2, {
                              key: 1,
                              icon: actionOrMenu.icon,
                              width: "16"
                            }, null, 8, ["icon"])) : createCommentVNode("", true),
                            createElementVNode("div", null, toDisplayString(actionOrMenu.label), 1)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                ], 64);
              }), 128))
            ])
          ])
        ], 16)) : createCommentVNode("", true)
      ]);
    };
  }
});
export {
  _sfc_main as _
};
